// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hn_ho","container":"hn_e","primaryDetails":"hn_hp","title":"hn_eg","row":"hn_fh","column":"hn_f","columnRight":"hn_hq"};